module.exports = base;


//////////////////
// WEBPACK FOOTER
// external "base"
// module id = 2
// module chunks = 22